import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

import 'react-app-polyfill/ie11'

import registerServiceWorker from './registerServiceWorker'

import App from 'scenes/App'
import store from 'store'

import 'index.css'


ReactDOM.render(
  <Provider store={ store }>
    <App />
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker()
